import hash from 'object-hash'

import {
  getActionsCreatedClosedForAudits,
  getActionsStatsForAudits,
  getAuditAssessmentTable,
  getAuditAverageTimeInBetween,
  getAuditCompliantRate,
  getAuditDatasetAverage,
  getAuditDatasetAverages,
  getAuditDatasetAveragesByFamily,
  getAuditDatasetAveragesChart,
  getAuditDatasetAverageScoreByFamilySpiderChart,
  getAuditDatasetNonComplianceByFamily,
  getAuditDatasetTotals,
  getAuditLatest,
  getAuditOperatorComplianceTable,
  getAuditsWorstCriteriaDataset,
  getAuditTotaReferenceStates,
  getCompletedAuditsPercentage,
  getComplianceActionsDeadlinesStats,
  getFiveSConformityRate,
} from 'frontend/communications/stats'

const CLIENT_CALLS = {
  auditAssessmentTable: getAuditAssessmentTable,
  auditDatasetAverage: getAuditDatasetAverage,
  auditDatasetAverages: getAuditDatasetAverages,
  auditDatasetAveragesByFamily: getAuditDatasetAveragesByFamily,
  auditDatasetAverageScoreByFamilySpiderChart: getAuditDatasetAverageScoreByFamilySpiderChart,
  auditDatasetAveragesChart: getAuditDatasetAveragesChart,
  auditDatasetNonComplianceByFamily: getAuditDatasetNonComplianceByFamily,
  auditDatasetTotals: getAuditDatasetTotals,
  auditLPAsDataset: getAuditDatasetTotals,
  auditOperatorComplianceTable: getAuditOperatorComplianceTable,
  AuditsWorstCriteriaDataset: getAuditsWorstCriteriaDataset,
  auditTotaReferenceStates: getAuditTotaReferenceStates,
  averageTimeInBetween: getAuditAverageTimeInBetween,
  closedActions: getActionsStatsForAudits,
  createdClosedActions: getActionsCreatedClosedForAudits,
  completedAuditsPercentage: getCompletedAuditsPercentage,
  latest: getAuditLatest,
  auditCompliantRate: getAuditCompliantRate,
  fiveSConformityRate: getFiveSConformityRate,
  complianceActionsDeadlines: getComplianceActionsDeadlinesStats,
}

function sendData (data, callbacks) {
  callbacks.forEach((callback) => {
    callback(data)
  })
}

const stateObj = {
  fetchedResponse: {},
}

const getters = {
}

const mutations = {
  resetFetchedResponses (key) {
    if (key) {
      delete stateObj.fetchedResponse[key]
    }
    stateObj.fetchedResponse = {}
  },
}

const actions = {
  fetchAuditStats ({ state }, payload) {
    const callback = payload.callback
    delete payload.callback
    const key = hash(payload)
    if (!(key in state.fetchedResponse)) {
      const fn = CLIENT_CALLS[payload.resource]
      fn(payload)
        .then((data) => {
          state.fetchedResponse[key] = {
            callbacks: [callback],
            data: data,
          }
          sendData(data, state.fetchedResponse[key].callbacks)
        })
    } else {
      if (!(callback in state.fetchedResponse[key].callbacks)) {
        state.fetchedResponse[key].callbacks.push(callback)
      }
      if (state.fetchedResponse[key].data !== null) {
        sendData(state.fetchedResponse[key].data, state.fetchedResponse[key].callbacks)
      }
    }
  },

}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
